<template>
  <label class="theme-sync">
    <span class="theme-sync__switch">
      <input
        type="checkbox"
        role="switch"
        :checked="isThemeSync"
        :aria-checked="String(isThemeSync)"
        @change="setThemeSync($event.target.checked)"
      />
      <span class="theme-sync__track" aria-hidden="true"></span>
    </span>
    <span class="theme-sync__text">
      <span class="theme-sync__title">
        {{ $t("settings.theme.sync.title") }}
      </span>
      <span class="theme-sync__description">
        {{
          isThemeSync
            ? $t("settings.theme.sync.on")
            : $t("settings.theme.sync.off")
        }}
      </span>
    </span>
  </label>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

// Синхронизация оформления между устройствами. Сам флаг хранится в базе
// (user.theme_sync), логика — в store/modules/appearance.js.
export default {
  name: "ThemeSyncToggle",
  computed: {
    ...mapGetters(["isThemeSync"]),
  },
  methods: {
    ...mapActions(["setThemeSync"]),
  },
};
</script>

<style lang="scss" scoped>
.theme-sync {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin: 16px 28px 0;
  padding: 12px 14px;
  border-radius: var(--radius-lg, 8px);
  background-color: color-mix(
    in srgb,
    var(--theme-color) 7%,
    var(--color-surface, #fff)
  );
  font-family: var(--font-family-body);
  cursor: pointer;
}

.theme-sync__switch {
  position: relative;
  flex-shrink: 0;
  width: 38px;
  height: 22px;
  margin-top: 1px;

  input {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    margin: 0;
    opacity: 0;
    cursor: pointer;
  }
}

.theme-sync__track {
  position: absolute;
  inset: 0;
  border-radius: 11px;
  background-color: var(--color-border, #dfe3e8);
  transition: background-color 0.15s ease;

  &::after {
    content: "";
    position: absolute;
    top: 2px;
    left: 2px;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background-color: #fff;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
    transition: transform 0.15s ease;
  }

  input:checked + & {
    background-color: var(--theme-color);

    &::after {
      transform: translateX(16px);
    }
  }

  input:focus-visible + & {
    box-shadow: 0 0 0 2px
      color-mix(in srgb, var(--theme-color) 35%, transparent);
  }
}

.theme-sync__text {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.theme-sync__title {
  color: var(--color-text-primary);
  font-size: var(--font-size-base, 14px);
  font-weight: 500;
  line-height: 1.35;
}

.theme-sync__description {
  color: var(--color-text-secondary);
  font-size: var(--font-size-sm, 12px);
  line-height: var(--line-height-normal, 1.45);
}
</style>
